module.exports = __webpack_public_path__ + "static/media/carousel3.e7fc9f45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/carousel3.jpg
// module id = 455
// module chunks = 16